// extracted by mini-css-extract-plugin
export default {"csrpage":"csrpage_csrpage__T9vJf","csr_module":"csrpage_csr_module__S2E4S","csr_module_info":"csrpage_csr_module_info__qknXA"};